var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 6.25008C23.8333 5.10425 22.8583 4.16675 21.6667 4.16675H4.33332C3.14166 4.16675 2.16666 5.10425 2.16666 6.25008M23.8333 6.25008V18.7501C23.8333 19.8959 22.8583 20.8334 21.6667 20.8334H4.33332C3.14166 20.8334 2.16666 19.8959 2.16666 18.7501V6.25008M23.8333 6.25008L13 13.5417L2.16666 6.25008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bf81223ceeea987bab304927c3068a50.svg";
export { ForwardRef as ReactComponent };